/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_borrarSesion as borrarSesion,
  rec_jt as jt,
  rec_obtenerToken as obtenerToken,
  rec_rt as rt,
  rec_sesionVencida as sesionVencida,
} from "../../runtime/index.jsx";
export function SesionRequerida(e) {
  let t = (0, ReactCompiler.c)(4),
    { children: n } = e,
    { pathname: r, search: i, hash: a } = rt(),
    o = obtenerToken() && sesionVencida();
  if (obtenerToken() && !o) return n;
  o && borrarSesion();
  let s = encodeURIComponent(`${r}${i}${a}`),
    c = r === `/` ? `` : `volver=${s}`,
    l;
  t[0] === c
    ? (l = t[1])
    : ((l = [o ? `expirada=1` : ``, c].filter(Boolean)),
      (t[0] = c),
      (t[1] = l));
  let u = l.join(`&`),
    d = `/login${u ? `?${u}` : ``}`,
    f;
  return (
    t[2] === d
      ? (f = t[3])
      : ((f = (0, JSXRuntime.jsx)(jt, {
          to: d,
          replace: !0,
        })),
        (t[2] = d),
        (t[3] = f)),
    f
  );
}
